import request from '@/http/request'
export const readRfid = (params, queryHeader) => {
  return request.post(`${process.env.REACT_APP_API_MAC_URL_PHONE}/rfid`, params, {
    nfc: true,
    // noSpin: true,
    RFHeader: queryHeader
  })
}

export const resetRfid = (params, queryHeader) => {
  return request.post(`${process.env.REACT_APP_API_MAC_URL_PHONE}/resetRfid`, params, {
    nfc: true,
    // noSpin: true,
    RFHeader: queryHeader
  })
}

export const demoBind = (params, queryHeader) => {
  return request.post(`${process.env.REACT_APP_API_MAC_URL_PHONE}/nfc-clc-service/nfc/demo/bind`, params, {
    nfc: true,
    // noSpin: true,
    RFHeader: queryHeader
  })
}
